import React from 'react';
import './Button.css';

const Button = ({
  onClick,
  disabled = false,
  label,
  style,
  icon,
  variant = 'primary',
  ...props
}) => {
  const classNames = `btn ${variant} ${disabled ? 'disabled' : ''}`;

  return (
    <button
      className={classNames}
      onClick={onClick}
      disabled={disabled}
      style={style}
      {...props}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      {label && <span className="btn-label">{label}</span>}
    </button>
  );
};

export default Button;
